export enum Roles {
  Administrator = "Administrator",
  User = "User",
  Customer = "Customer",
  Operator = "Operator",
}
